import { render, staticRenderFns } from "./Enteringsubsidies.vue?vue&type=template&id=751ff30e&"
import script from "./Enteringsubsidies.vue?vue&type=script&lang=js&"
export * from "./Enteringsubsidies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports